export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_IS_LOADING = 'GET_IS_LOADING';